module.exports = __webpack_public_path__ + "static/media/feeling-bad3.54f19960.svg";